import React from 'react';
import { motion } from 'framer-motion';
import { format, addDays, startOfWeek } from 'date-fns';
import { mockCalendarData } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';
import { FiFilter, FiTwitter, FiLinkedin, FiInstagram, FiMail } from 'react-icons/fi';

export default function CalendarView() {
  const startDate = startOfWeek(new Date(), { weekStartsOn: 1 });
  const weekDays = Array.from({ length: 7 }).map((_, i) => addDays(startDate, i));

  const getIcon = (type) => {
    switch(type) {
      case 'Twitter': return FiTwitter;
      case 'LinkedIn': return FiLinkedin;
      case 'Instagram': return FiInstagram;
      case 'Email': return FiMail;
      default: return FiMail;
    }
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'scheduled': return 'border-blue-500/50 bg-blue-500/10 text-blue-400';
      case 'approved': return 'border-green-500/50 bg-green-500/10 text-green-400';
      case 'draft': return 'border-yellow-500/50 bg-yellow-500/10 text-yellow-400';
      default: return 'border-gray-500/50 bg-gray-500/10 text-gray-400';
    }
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="p-8 max-w-7xl mx-auto h-full flex flex-col">
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-2">
          <button className="bg-[#141414] border border-[#2a2a2a] text-white px-4 py-2 rounded-lg text-sm hover:border-[#FF5A5F] transition-colors">Week</button>
          <button className="bg-transparent text-gray-500 px-4 py-2 rounded-lg text-sm hover:text-white transition-colors">Month</button>
        </div>
        
        <div className="flex gap-4">
          <div className="flex items-center gap-2 bg-[#141414] border border-[#2a2a2a] rounded-lg px-3 py-1">
            <SafeIcon icon={FiTwitter} className="text-gray-400" />
            <SafeIcon icon={FiLinkedin} className="text-gray-400" />
            <SafeIcon icon={FiInstagram} className="text-[#FF5A5F]" />
          </div>
          <button className="flex items-center gap-2 text-gray-400 hover:text-white text-sm">
            <SafeIcon icon={FiFilter} /> Filters
          </button>
        </div>
      </div>

      <div className="flex-1 glass-panel overflow-hidden flex flex-col">
        <div className="grid grid-cols-7 border-b border-[#2a2a2a] bg-[#0a0a0a]">
          {weekDays.map((date, i) => (
            <div key={i} className="p-4 text-center border-r border-[#1a1a1a] last:border-r-0">
              <div className="text-xs text-gray-500 uppercase tracking-widest mb-1">{format(date, 'EEE')}</div>
              <div className={`text-lg ${format(date, 'd') === format(new Date(), 'd') ? 'text-[#FF5A5F] font-bold' : 'text-white'}`}>
                {format(date, 'd')}
              </div>
            </div>
          ))}
        </div>
        
        <div className="flex-1 grid grid-cols-7 overflow-y-auto">
          {weekDays.map((date, i) => (
            <div key={i} className="border-r border-[#1a1a1a] last:border-r-0 p-2 min-h-[200px] hover:bg-[#111] transition-colors">
              {mockCalendarData
                .filter(item => format(item.date, 'yyyy-MM-dd') === format(date, 'yyyy-MM-dd'))
                .map(item => (
                  <div key={item.id} className={`p-3 mb-2 rounded-lg border ${getStatusColor(item.status)} cursor-pointer hover:-translate-y-0.5 transition-transform`}>
                    <div className="flex justify-between items-start mb-2">
                      <SafeIcon icon={getIcon(item.type)} className="text-sm opacity-80" />
                      <span className="text-[10px] uppercase font-mono opacity-80">{item.time}</span>
                    </div>
                    <div className="text-xs font-medium truncate">{item.title}</div>
                  </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
}